import { useBuilding, useBuildingBookings } from "@/api";
import { WELCOME_BOOKING_URL } from "@/lib";
import { createFileRoute } from "@tanstack/react-router";
import { Trans, useTranslation } from "react-i18next";
import { useWelcomeBookingAccess } from "@/hooks/useWelcomeBookingAccess";
import BookingAdminView from "@/components/bookings/BookingAdminView";
import { useBuildingAdminOrReceptionistAccess } from "@/hooks/useReceptionistAccess";

export const Route = createFileRoute("/_portal/building/bookings/")({
  component: BuildingBookings,
});

function BuildingBookings() {
  const { t, i18n } = useTranslation();
  const { allowBuildingAdminOrReceptionistAccess } =
    useBuildingAdminOrReceptionistAccess();
  const { allowWelcomeBookingAccess } = useWelcomeBookingAccess();
  const { data: building } = useBuilding();

  if (!allowBuildingAdminOrReceptionistAccess || !allowWelcomeBookingAccess)
    return null;
  return (
    <>
      <div className="pageHeader">
        <h1>{t("PAGES.BUILDING_BOOKING.HEADER")}</h1>
        <p>
          <Trans
            i18nKey="PAGES.BUILDING_BOOKING.SUBHEADER"
            values={{ buildingName: building.displayName }}
          >
            Text
            <a href={WELCOME_BOOKING_URL(i18n.language)} target="_blank">
              link
            </a>
            .
          </Trans>
        </p>
      </div>
      <BookingAdminView
        buildingAdminMode
        newBookingPath="/building/bookings/new"
        getBookingsFn={useBuildingBookings}
      />
    </>
  );
}
